var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System / Camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.90748 5.83333H5.16683C4.23341 5.83333 3.76635 5.83333 3.40983 6.01499C3.09623 6.17478 2.84144 6.42956 2.68166 6.74316C2.5 7.09968 2.5 7.56674 2.5 8.50016V13.1668C2.5 14.1003 2.5 14.5663 2.68166 14.9228C2.84144 15.2364 3.09623 15.4921 3.40983 15.6519C3.766 15.8333 4.23249 15.8333 5.16409 15.8333H14.8359C15.7675 15.8333 16.2333 15.8333 16.5895 15.6519C16.9031 15.4921 17.1587 15.2364 17.3185 14.9228C17.5 14.5667 17.5 14.1008 17.5 13.1692V8.49742C17.5 7.56583 17.5 7.09933 17.3185 6.74316C17.1587 6.42956 16.9031 6.17478 16.5895 6.01499C16.233 5.83333 15.7669 5.83333 14.8335 5.83333H12.0924M7.90748 5.83333H7.95898M7.90748 5.83333C7.91792 5.83334 7.9289 5.83334 7.94047 5.83333L7.95898 5.83333M7.90748 5.83333C7.81905 5.8333 7.76949 5.83284 7.73031 5.82845C7.24065 5.77363 6.90482 5.30756 7.00765 4.8257C7.01722 4.78086 7.03613 4.72412 7.07359 4.61176L7.0752 4.60701C7.11797 4.47869 7.13936 4.41453 7.16298 4.35791C7.40489 3.77824 7.95268 3.38402 8.5791 3.33784C8.64029 3.33333 8.70751 3.33333 8.84277 3.33333H11.1572C11.2924 3.33333 11.3602 3.33333 11.4214 3.33784C12.0478 3.38402 12.595 3.77824 12.8369 4.35791C12.8605 4.41453 12.882 4.47862 12.9248 4.60693C12.9633 4.72249 12.9826 4.7803 12.9923 4.82578C13.0951 5.30764 12.7598 5.77363 12.2702 5.82845C12.231 5.83284 12.1809 5.8333 12.0924 5.83333M7.95898 5.83333H12.0408M12.0408 5.83333H12.0924M12.0408 5.83333L12.0593 5.83333C12.0709 5.83334 12.0819 5.83334 12.0924 5.83333M10 13.3333C8.61929 13.3333 7.5 12.214 7.5 10.8333C7.5 9.45262 8.61929 8.33333 10 8.33333C11.3807 8.33333 12.5 9.45262 12.5 10.8333C12.5 12.214 11.3807 13.3333 10 13.3333Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCamera);
export default __webpack_public_path__ + "static/media/nav-camera.7195c306a10c600adb4364b9fcb1df9e.svg";
export { ForwardRef as ReactComponent };